import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "context-panel__header" }
const _hoisted_2 = { class: "context-panel__title" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "context-panel__content" }
const _hoisted_5 = {
  key: 0,
  class: "context-panel__section"
}
const _hoisted_6 = { class: "context-panel__section-title" }
const _hoisted_7 = { class: "control-group" }
const _hoisted_8 = { class: "control-label" }
const _hoisted_9 = { class: "control-with-value" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "control-value-display" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "value-text" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "control-group" }
const _hoisted_16 = { class: "control-label" }
const _hoisted_17 = { class: "control-with-value" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "control-value-display" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "value-text" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "control-group" }
const _hoisted_24 = { class: "control-label" }
const _hoisted_25 = { class: "color-display" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "color-value" }
const _hoisted_28 = {
  key: 1,
  class: "context-panel__section"
}
const _hoisted_29 = { class: "context-panel__section-title" }
const _hoisted_30 = { class: "control-group" }
const _hoisted_31 = { class: "control-label" }
const _hoisted_32 = { class: "control-with-value" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "control-value-display" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "control-group" }
const _hoisted_39 = { class: "control-label" }
const _hoisted_40 = { class: "color-display" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "color-value" }
const _hoisted_43 = {
  key: 2,
  class: "context-panel__section"
}
const _hoisted_44 = { class: "context-panel__section-title" }
const _hoisted_45 = { class: "control-group" }
const _hoisted_46 = { class: "control-label" }
const _hoisted_47 = { class: "scale-input-wrapper" }
const _hoisted_48 = ["value", "title"]
const _hoisted_49 = { class: "scale-presets" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "control-group" }
const _hoisted_52 = { class: "control-label" }
const _hoisted_53 = { class: "unit-selector" }
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = { class: "control-group" }
const _hoisted_56 = ["title"]
const _hoisted_57 = { class: "control-group" }
const _hoisted_58 = { class: "control-label" }
const _hoisted_59 = { class: "control-with-value" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "value-text-inline" }
const _hoisted_62 = { class: "control-group" }
const _hoisted_63 = { class: "control-label" }
const _hoisted_64 = { class: "color-display" }
const _hoisted_65 = ["title"]
const _hoisted_66 = { class: "color-value" }
const _hoisted_67 = {
  key: 3,
  class: "context-panel__section"
}
const _hoisted_68 = { class: "context-panel__section-title" }
const _hoisted_69 = { class: "control-group" }
const _hoisted_70 = { class: "control-label" }
const _hoisted_71 = { class: "control-with-value" }
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "value-text-inline" }
const _hoisted_74 = { class: "control-group" }
const _hoisted_75 = { class: "control-label" }
const _hoisted_76 = { class: "color-display" }
const _hoisted_77 = ["title"]
const _hoisted_78 = { class: "color-value" }
const _hoisted_79 = {
  key: 0,
  class: "context-panel__footer"
}

import { ref, computed, watch, nextTick, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { AnnotationTool, type AnnotationToolSettings } from '@/types/annotation';

interface Props {
  currentTool: AnnotationTool;
  settings: AnnotationToolSettings;
  isVisible: boolean;
  anchorElement?: HTMLElement | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnotationContextPanel',
  props: {
    currentTool: {},
    settings: {},
    isVisible: { type: Boolean, default: true },
    anchorElement: { default: null }
  },
  emits: ["setting-change", "calibrate-scale", "open-color-picker", "close"],
  setup(__props: any, { emit: __emit }) {

// @ts-ignore
const props = __props;

const emit = __emit;

const { t } = useI18n();

// Panel reference
const panelRef = ref<HTMLElement | null>(null);

// Panel positioning
const panelPosition = ref({
  top: '80px',
  left: '20px',
});

// Scale presets
const scalePresets = [50, 75, 100, 150, 200];

// Measurement units
const measurementUnits = [
  { value: 'meters', label: 'Meters', short: 'm' },
  { value: 'feet', label: 'Feet', short: 'ft' },
  { value: 'inches', label: 'Inches', short: 'in' },
];

// Tool type checks
const isDrawingTool = computed(() => {
  return ['freehand', 'rectangle', 'circle', 'arrow', 'line', 'eraser'].includes(props.currentTool);
});

const isMeasurementTool = computed(() => {
  return ['measure-distance', 'measure-area', 'measure-polygon'].includes(props.currentTool);
});

// Panel classes
const panelClasses = computed(() => ({
  'context-panel--drawing': isDrawingTool.value,
  'context-panel--measurement': isMeasurementTool.value,
  'context-panel--text': props.currentTool === 'text',
  'context-panel--highlight': props.currentTool === 'highlight',
}));

// Tool metadata
const toolMetadata: Record<string, { icon: string; label: string; tip?: string }> = {
  'freehand': { 
    icon: 'fas fa-pencil-alt', 
    label: 'Freehand Drawing',
    tip: 'Click and drag to draw freehand shapes'
  },
  'rectangle': { 
    icon: 'fas fa-square', 
    label: 'Rectangle',
    tip: 'Click and drag to create a rectangle'
  },
  'circle': { 
    icon: 'fas fa-circle', 
    label: 'Circle',
    tip: 'Click and drag to create a circle'
  },
  'arrow': { 
    icon: 'fas fa-arrow-right', 
    label: 'Arrow',
    tip: 'Click to set start point, click again to set end point'
  },
  'line': { 
    icon: 'fas fa-minus', 
    label: 'Line',
    tip: 'Click to set start point, click again to set end point'
  },
  'text': { 
    icon: 'fas fa-font', 
    label: 'Text',
    tip: 'Click to place text on the document'
  },
  'highlight': { 
    icon: 'fas fa-highlighter', 
    label: 'Highlight',
    tip: 'Click and drag to highlight areas'
  },
  'measure-distance': { 
    icon: 'fas fa-ruler', 
    label: 'Measure Distance',
    tip: 'Click to set points, press Enter to finish'
  },
  'measure-area': { 
    icon: 'fas fa-draw-polygon', 
    label: 'Measure Area',
    tip: 'Click to set points, press Enter to close shape'
  },
  'measure-polygon': { 
    icon: 'fas fa-shapes', 
    label: 'Measure Polygon',
    tip: 'Click to set vertices, press Enter to finish'
  },
  'eraser': { 
    icon: 'fas fa-eraser', 
    label: 'Eraser',
    tip: 'Click on annotations to remove them'
  },
};

// Get tool metadata
const getToolIcon = (tool: string): string => {
  return toolMetadata[tool]?.icon || 'fas fa-question';
};

const getToolLabel = (tool: string): string => {
  return t(`annotation.${tool}`) || toolMetadata[tool]?.label || tool;
};

const getToolTip = (tool: string): string | undefined => {
  return toolMetadata[tool]?.tip;
};

// Calculate panel position
const calculatePosition = () => {
  if (!props.anchorElement || !panelRef.value) {
    // Default position
    panelPosition.value = {
      top: '80px',
      left: '20px',
    };
    return;
  }

  const anchorRect = props.anchorElement.getBoundingClientRect();
  const panelRect = panelRef.value.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  // Try to position below the toolbar
  let top = anchorRect.bottom + 8;
  let left = anchorRect.left + 20;

  // Check if panel would overflow right edge
  if (left + panelRect.width > viewportWidth) {
    left = viewportWidth - panelRect.width - 20;
  }

  // Check if panel would overflow bottom edge
  if (top + panelRect.height > viewportHeight) {
    // Position above the toolbar instead
    top = anchorRect.top - panelRect.height - 8;
  }

  // Ensure minimum margins
  left = Math.max(20, left);
  top = Math.max(20, top);

  panelPosition.value = {
    top: `${top}px`,
    left: `${left}px`,
  };
};

// Watch for visibility and tool changes to recalculate position
watch([() => props.isVisible, () => props.currentTool], () => {
  if (props.isVisible) {
    nextTick(() => {
      calculatePosition();
    });
  }
});

// Recalculate on window resize
const handleResize = () => {
  if (props.isVisible) {
    calculatePosition();
  }
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
  if (props.isVisible) {
    nextTick(() => {
      calculatePosition();
    });
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

// Event handlers
const handleStrokeWidthChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('setting-change', 'strokeWidth', parseInt(target.value));
};

const adjustStrokeWidth = (delta: number) => {
  const newValue = Math.max(1, Math.min(20, props.settings.strokeWidth + delta));
  emit('setting-change', 'strokeWidth', newValue);
};

const handleOpacityChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const opacity = parseInt(target.value) / 100;
  emit('setting-change', 'opacity', opacity);
};

const adjustOpacity = (delta: number) => {
  const currentOpacity = Math.round(props.settings.opacity * 100);
  const newOpacity = Math.max(0, Math.min(100, currentOpacity + delta)) / 100;
  emit('setting-change', 'opacity', newOpacity);
};

const handleFontSizeChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('setting-change', 'fontSize', parseInt(target.value));
};

const adjustFontSize = (delta: number) => {
  const newValue = Math.max(8, Math.min(72, props.settings.fontSize + delta));
  emit('setting-change', 'fontSize', newValue);
};

const getCurrentScaleValue = (): number => {
  const currentScale = props.settings.scale || '1:100';
  const parts = currentScale.split(':');
  return parseFloat(parts[1]) || 100;
};

const handleCustomScaleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const value = parseFloat(target.value);
  
  if (value && value > 0) {
    const scaleLabel = `1:${value}`;
    emit('setting-change', 'scale', scaleLabel);
    emit('setting-change', 'scaleRatio', value);
  }
};

const handleCustomScaleBlur = (e: Event) => {
  const target = e.target as HTMLInputElement;
  let value = parseFloat(target.value);
  
  if (!value || value < 1) {
    value = 100;
    target.value = '100';
  }
  
  const scaleLabel = `1:${value}`;
  emit('setting-change', 'scale', scaleLabel);
  emit('setting-change', 'scaleRatio', value);
};

const setScale = (value: number) => {
  const scaleLabel = `1:${value}`;
  emit('setting-change', 'scale', scaleLabel);
  emit('setting-change', 'scaleRatio', value);
};

const handleUnitChange = (unit: string) => {
  emit('setting-change', 'measurementUnit', unit);
};

const handleClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "context-panel" }, {
      default: _withCtx(() => [
        (_ctx.isVisible && _ctx.currentTool !== 'select')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "panelRef",
              ref: panelRef,
              class: _normalizeClass(["annotation-context-panel", panelClasses.value]),
              style: _normalizeStyle(panelPosition.value)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("i", {
                    class: _normalizeClass([getToolIcon(_ctx.currentTool), "context-panel__icon"])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(getToolLabel(_ctx.currentTool)), 1)
                ]),
                _createElementVNode("button", {
                  class: "context-panel__close",
                  onClick: handleClose,
                  title: _ctx.$t('common.close') || 'Close'
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))], 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (isDrawingTool.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('annotation.strokeSettings') || 'Stroke Settings'), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('annotation.strokeWidth') || 'Width'), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("input", {
                            type: "range",
                            min: "1",
                            max: "20",
                            value: _ctx.settings.strokeWidth,
                            onInput: handleStrokeWidthChange,
                            class: "slider"
                          }, null, 40, _hoisted_10),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                              class: "value-btn value-btn--minus",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (adjustStrokeWidth(-1))),
                              disabled: _ctx.settings.strokeWidth <= 1
                            }, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                            ]))], 8, _hoisted_12),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.settings.strokeWidth) + "px", 1),
                            _createElementVNode("button", {
                              class: "value-btn value-btn--plus",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (adjustStrokeWidth(1))),
                              disabled: _ctx.settings.strokeWidth >= 20
                            }, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
                            ]))], 8, _hoisted_14)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('annotation.opacity') || 'Opacity'), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("input", {
                            type: "range",
                            min: "0",
                            max: "100",
                            value: _ctx.settings.opacity * 100,
                            onInput: handleOpacityChange,
                            class: "slider"
                          }, null, 40, _hoisted_18),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              class: "value-btn value-btn--minus",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (adjustOpacity(-10))),
                              disabled: _ctx.settings.opacity <= 0
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                            ]))], 8, _hoisted_20),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(Math.round(_ctx.settings.opacity * 100)) + "%", 1),
                            _createElementVNode("button", {
                              class: "value-btn value-btn--plus",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (adjustOpacity(10))),
                              disabled: _ctx.settings.opacity >= 1
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
                            ]))], 8, _hoisted_22)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "opacity-preview",
                          style: _normalizeStyle({ opacity: _ctx.settings.opacity, backgroundColor: _ctx.settings.strokeColor })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('annotation.color') || 'Color'), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", {
                            class: "color-swatch-large",
                            style: _normalizeStyle({ backgroundColor: _ctx.settings.strokeColor }),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-color-picker'))),
                            title: _ctx.$t('annotation.selectColor') || 'Click to change color'
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("i", { class: "fas fa-palette color-swatch-icon" }, null, -1)
                          ]))], 12, _hoisted_26),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.settings.strokeColor), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentTool === 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('annotation.textSettings') || 'Text Settings'), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('annotation.fontSize') || 'Font Size'), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("input", {
                            type: "range",
                            min: "8",
                            max: "72",
                            value: _ctx.settings.fontSize,
                            onInput: handleFontSizeChange,
                            class: "slider"
                          }, null, 40, _hoisted_33),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "value-btn value-btn--minus",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (adjustFontSize(-2))),
                              disabled: _ctx.settings.fontSize <= 8
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                            ]))], 8, _hoisted_35),
                            _createElementVNode("input", {
                              type: "number",
                              min: "8",
                              max: "72",
                              value: _ctx.settings.fontSize,
                              onInput: handleFontSizeChange,
                              class: "value-input"
                            }, null, 40, _hoisted_36),
                            _createElementVNode("button", {
                              class: "value-btn value-btn--plus",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (adjustFontSize(2))),
                              disabled: _ctx.settings.fontSize >= 72
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
                            ]))], 8, _hoisted_37)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('annotation.color') || 'Color'), 1),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", {
                            class: "color-swatch-large",
                            style: _normalizeStyle({ backgroundColor: _ctx.settings.strokeColor }),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('open-color-picker'))),
                            title: _ctx.$t('annotation.selectColor') || 'Click to change color'
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fas fa-palette color-swatch-icon" }, null, -1)
                          ]))], 12, _hoisted_41),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.settings.strokeColor), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isMeasurementTool.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('annotation.measurementSettings') || 'Measurement Settings'), 1),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('annotation.scale') || 'Scale'), 1),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "scale-prefix" }, "1:", -1)),
                          _createElementVNode("input", {
                            type: "number",
                            value: getCurrentScaleValue(),
                            onInput: handleCustomScaleInput,
                            onBlur: handleCustomScaleBlur,
                            onKeypress: _withKeys(handleCustomScaleBlur, ["enter"]),
                            class: "scale-input",
                            min: "1",
                            step: "1",
                            placeholder: "100",
                            title: _ctx.$t('annotation.scaleRatio') || 'Scale ratio (e.g., 100 for 1:100)'
                          }, null, 40, _hoisted_48)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scalePresets, (preset) => {
                            return _createElementVNode("button", {
                              key: preset,
                              class: _normalizeClass(["preset-btn", { active: getCurrentScaleValue() === preset }]),
                              onClick: ($event: any) => (setScale(preset))
                            }, " 1:" + _toDisplayString(preset), 11, _hoisted_50)
                          }), 64))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('annotation.unit') || 'Unit'), 1),
                        _createElementVNode("div", _hoisted_53, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(measurementUnits, (unit) => {
                            return _createElementVNode("button", {
                              key: unit.value,
                              class: _normalizeClass(["unit-btn", { active: (_ctx.settings.measurementUnit || 'meters') === unit.value }]),
                              onClick: ($event: any) => (handleUnitChange(unit.value)),
                              title: unit.label
                            }, _toDisplayString(unit.short), 11, _hoisted_54)
                          }), 64))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          class: "btn-calibrate",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('calibrate-scale'))),
                          title: _ctx.$t('annotation.calibrateScale') || 'Calibrate scale with known distance'
                        }, [
                          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-ruler-combined" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('annotation.calibrate') || 'Calibrate'), 1)
                        ], 8, _hoisted_56)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('annotation.lineWidth') || 'Line Width'), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("input", {
                            type: "range",
                            min: "1",
                            max: "10",
                            value: _ctx.settings.strokeWidth,
                            onInput: handleStrokeWidthChange,
                            class: "slider"
                          }, null, 40, _hoisted_60),
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.settings.strokeWidth) + "px", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('annotation.color') || 'Color'), 1),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", {
                            class: "color-swatch-large",
                            style: _normalizeStyle({ backgroundColor: _ctx.settings.strokeColor }),
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('open-color-picker'))),
                            title: _ctx.$t('annotation.selectColor') || 'Click to change color'
                          }, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "fas fa-palette color-swatch-icon" }, null, -1)
                          ]))], 12, _hoisted_65),
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.settings.strokeColor), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currentTool === 'highlight')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('annotation.highlightSettings') || 'Highlight Settings'), 1),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('annotation.opacity') || 'Opacity'), 1),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("input", {
                            type: "range",
                            min: "0",
                            max: "100",
                            value: _ctx.settings.opacity * 100,
                            onInput: handleOpacityChange,
                            class: "slider"
                          }, null, 40, _hoisted_72),
                          _createElementVNode("span", _hoisted_73, _toDisplayString(Math.round(_ctx.settings.opacity * 100)) + "%", 1)
                        ]),
                        _createElementVNode("div", {
                          class: "opacity-preview",
                          style: _normalizeStyle({ opacity: _ctx.settings.opacity, backgroundColor: _ctx.settings.strokeColor })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('annotation.color') || 'Color'), 1),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", {
                            class: "color-swatch-large",
                            style: _normalizeStyle({ backgroundColor: _ctx.settings.strokeColor }),
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('open-color-picker'))),
                            title: _ctx.$t('annotation.selectColor') || 'Click to change color'
                          }, [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("i", { class: "fas fa-palette color-swatch-icon" }, null, -1)
                          ]))], 12, _hoisted_77),
                          _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.settings.strokeColor), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (getToolTip(_ctx.currentTool))
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-lightbulb" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(getToolTip(_ctx.currentTool)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})